exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".scope-assessment[data-v-4c0e00d7] .ant-select {\n  max-height: 80px !important;\n  overflow-y: auto !important;\n}\n.mood-light-modal[data-v-4c0e00d7] .ant-modal-header {\n  padding: 10px 24px;\n}\n", ""]);

// exports
